import {
  SelectChangeEvent,
  SelectProps
} from '@mui/material';
import { StyledDropDown } from 'modules';
import { ChangeEvent } from 'react';
import * as ds from './dataService';



export type ListedCompanyTrendDropDownProps = {
  handleChange: (e: SelectChangeEvent<unknown> | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  name: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: ListedCompanyTrendDropDownProps & SelectProps) => {
  const { data } = ds.useQuery();

  return (
    <StyledDropDown.FC
      options={[...data]}
      value={props.name}
      onChange={(e) => {
        props.handleChange(e);
      }}

    />

  );
};
